import { LitElement, html, css } from "lit";

export class IntervalTrigger extends LitElement {
  static properties = {
    value: { type: Number },
  };

  constructor() {
    super();
    this.value = 5;
  }

  static styles = css`
    :host {
      display: inline-block;
    }
  `;

  _open() {
    this.dispatchEvent(
      new CustomEvent("open-dial", { bubbles: true, composed: true }),
    );
  }

  render() {
    return html`
      <wa-button circle @click=${this._open}>${this.value}s</wa-button>
    `;
  }
}

customElements.define("interval-trigger", IntervalTrigger);
